// 로그인하러 떠나기 전에 가려던 주소를 기억했다가, 돌아오면 그리로 보낸다.
//
// 예전에는 `CallbackPage` 가 어디서 왔든 무조건 `DEFAULT_TAB_PATH`(문제지 목록)로
// 보냈다. 그래서 **지인에듀 랜딩에서 레벨테스트 화면으로 걸어 둔 링크가 로그인을
// 거치면 엉뚱한 화면에 떨어졌다.** 처음 들어온 사람일수록 로그인을 거치므로, 정작
// 데려오려던 사람이 목적지를 못 보는 구조였다.
//
// `sessionStorage` 를 쓴다. 탭을 닫으면 사라지므로 다음에 그냥 로그인했을 때
// 옛날 목적지로 끌려가는 일이 없다.

const STORAGE_KEY = "post_login_redirect";

// 우리 앱 안의 주소만 받는다. `//evil.com` 같은 값이 들어오면 그대로 navigate 했을 때
// 바깥으로 튕겨 나간다(open redirect). 슬래시 하나로 시작하는 경로만 통과시킨다.
const isSafeInternalPath = (path) =>
  typeof path === "string" && /^\/(?!\/)/.test(path);

export const savePostLoginRedirect = (path) => {
  if (!isSafeInternalPath(path)) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, path);
  } catch (error) {
    // 시크릿 모드 등에서 막힐 수 있다. 기억을 못 할 뿐이라 그냥 넘어간다.
  }
};

// 꺼내면서 지운다. 한 번 쓰고 마는 값이다.
export const consumePostLoginRedirect = () => {
  try {
    const path = window.sessionStorage.getItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY);
    return isSafeInternalPath(path) ? path : "";
  } catch (error) {
    return "";
  }
};
